export default __webpack_public_path__ + "228faa03a453272288e4701ed871fcca.png";